import React from "react";
import Verticle_Categories from "../Near-me/Scan-mart-store/verticle_categories/Verticle_Categories";
import "./Store_Details.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
  faPhone,
  faShare,
  faShareNodes,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import Product_Info_Card from "../Common-Component/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Product_Info_Card_2 from "../Common-Component/product_info_card_2/Product_Info_Card_2";
import Shop_By_Brands from "./shop_by_brands/Shop_By_Brands";
import New_In_Store from "./new_in_store/New_In_Store";
import { useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { Context } from "../../utils/context";
import { decodeId, encodeId } from "../../utils/common";

const Store_Details = () => {
  // const { id } = useParams();

  const { id: encodedId } = useParams();
  const id = decodeId(encodedId);

  const [store, setStore] = useState(null);
  const { getData, IMG_URL, currentLocation } = useContext(Context);
  const [categories, setCategories] = useState([]);
  const [stores, setStores] = useState([]);
  const [offerProducts, setOfferProducts] = useState([]);
  const [noProducts, setNoProducts] = useState(false);
  const [selectId, setSelectId] = useState();

  const fetchOfferProducts = async (userId) => {
    const city =
      currentLocation?.city ||currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const res = await getData(
      `/without-login/product/offer-product?user_id=${userId}&city=${city}`,
    );

    if (res?.success) {
      setOfferProducts(res.data || []);
    }
  };
 const fetchCategories = async (user_id) => {
      const res = await getData(`/without-login/allcategories?user_id=${user_id}`);
      if (res?.success) {
        setCategories(res.data);
      }
    };
  // Fetch ALL categories
  useEffect(() => {
    fetchCategories(store?.user_id);
  }, [store?.user_id]);

  // Fetch ALL products of store user
  const fetchStoreProducts = async (userId, selectId) => {
    const city =
      currentLocation?.city ||currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const res = await getData(
      `/without-login/product?user_id=${userId}&category_id=${selectId || ""}&city=${city}`,
    );
    if (res?.success) {
      setStores(res?.data?.data || []);
    }
  };

  // On category click
  const handleCategorySelect = async (item) => {
    if (!store) return;

    const userId = store?.user_id;

    if (item === "All") {
      fetchStoreProducts(userId, selectId);
      setNoProducts(false);
      return;
    }

    const res = await getData(
      `/without-login/product?user_id=${userId}&category_id=${item.id}`,
    );

    if (res?.success) {
      const products = res?.data?.data || [];
      setStores(products);

      if (products.length === 0) {
        setNoProducts(true);
      } else {
        setNoProducts(false);
      }
    }
  };

  // Fetch store details + products

  useEffect(() => {
    const fetchStoreDetails = async () => {
      const res = await getData(`/shop/${id}`);

      if (res?.success) {
        setStore(res.data);

        const userId = res.data.user_id;

        //  Fetch all store products
        fetchStoreProducts(userId, selectId);

        //  Fetch offer products for this seller
        fetchOfferProducts(userId);
      }
    };

    fetchStoreDetails();
  }, [id, selectId, currentLocation]);

  const productUrl = `${window.location.origin}/store-details/${encodeId(id)}`;

  const handleShare = () => {
    const url = productUrl || window.location.href;
    const title = store?.name;

    if (navigator.share) {
      // Native share (mobile + some desktop browsers)
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      // Fallback: Open social share links (example: WhatsApp)
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`,
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <section className="Store_Details near_mart_store">
      <div className="container">
        <div className="all_content_holder two_content_holder">
          <div className="left_side">
            <Verticle_Categories
              setSelectId={setSelectId}
              selectId={selectId}
              category={categories}
              onCategorySelect={handleCategorySelect}
            />
          </div>

          <div className="details_div">
            <div className="top_div">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="store_details_div">
                    <div className="img_div">
                      <img
                        // src="/assets/Image/store_details/img.png"
                        src={IMG_URL + store?.logo}
                        className="store_img"
                      />
                    </div>

                    <div className="white_card">
                      <div className="top_content_div">
                        <p className="title_text">{store?.shop_name}</p>

                        <div className="all_icons_holder">
                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faShareNodes}
                              className="inner_icon"
                              onClick={handleShare}
                            />
                          </div>
                          {/* <div
                            className="icon_holder"
                            onClick={() =>
                              (window.location.href = `tel:${store?.whatsapp_number}`)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <FontAwesomeIcon
                              icon={faMessage}
                              className="inner_icon"
                            />
                          </div> */}

                          {/* <div
                            className="icon_holder"
                            onClick={() =>
                              (window.location.href = `tel:${store?.whatsapp_number}`)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <FontAwesomeIcon
                              icon={faPhone}
                              className="inner_icon"
                            />
                          </div> */}

                          {/* <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faPhone}
                              className="inner_icon"
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className="review_div">
                        <p className="rate_text">
                          <FontAwesomeIcon
                            icon={faStar}
                            className="icon_class"
                          />
                          {Number(store?.average_rating).toFixed(1)}
                        </p>
                        <p className="review_text">
                          Based on {store?.total_reviews} Reviews
                        </p>
                      </div>

                      <div className="bottom_divs">
                        <div className="common_div div1">
                          <p className="inner_text">
                            Delivery <b>Free</b>
                          </p>
                        </div>
                        <div className="common_div div2">
                          <p className="inner_text">
                            Delivery time{" "}
                            <b>
                              {store?.user?.vender_app_setup?.delivery_time ||
                                10}{" "}
                              mins
                            </b>
                          </p>
                        </div>
                        <div className="common_div div3">
                          <p className="inner_text">
                            Delivered by <b>{store?.shop_name}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-12">
                  <div className="main_swiper_div">
                    <Swiper
                      spaceBetween={15}
                      pagination={{
                        dynamicBullets: true,
                        clickable: true,
                      }}
                      //   modules={[Pagination]}
                      autoplay={{ delay: 300 }}
                      className="common_swiper"
                      breakpoints={{
                        0: {
                          slidesPerView: 2,
                          spaceBetween: 5,
                        },
                        380: {
                          slidesPerView: 2,
                          spaceBetween: 5,
                        },
                        480: {
                          slidesPerView: 2.5,
                        },
                        576: {
                          slidesPerView: 1.8,
                        },
                        768: {
                          slidesPerView: 2.4,
                        },
                        992: {
                          slidesPerView: 3,
                        },
                        1200: {
                          slidesPerView: 2,
                        },
                        1400: {
                          slidesPerView: 2,
                        },
                      }}
                    >
                      {offerProducts?.map((item) => {
                        const product = item.product;
                        const variant = product?.product_variants?.[0];

                        return (
                          <SwiperSlide key={item.id}>
                            <Product_Info_Card
                              item={item}
                              product={{
                                ...product,
                                product_variants: [variant],
                              }}
                              showQty
                            />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            <div className="more_prods_div">
              {stores?.length <= 0 ? (
                <p className="no_products_text">No products available</p>
              ) : (
                <div className="more_prods_swiper_div">
                  <Swiper
                    spaceBetween={15}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    autoplay={{ delay: 300 }}
                    className="common_swiper"
                    breakpoints={{
                      0: { slidesPerView: 1.5, spaceBetween: 5 },
                      380: { slidesPerView: 2, spaceBetween: 5 },
                      480: { slidesPerView: 2.5 },
                      576: { slidesPerView: 2 },
                      768: { slidesPerView: 2.4 },
                      992: { slidesPerView: 3.3 },
                      1200: { slidesPerView: 4 },
                      1400: { slidesPerView: 4.8 },
                    }}
                  >
                    {stores?.map((product) => {
                      const variant = product?.product_variants?.[0];
                      return (
                        <SwiperSlide key={product.id}>
                          <Product_Info_Card_2
                            product={product}
                            showQty
                            image={IMG_URL + product?.image1}
                            product_id={product?.id}
                            variant_id={variant?.id}
                            prodname={product?.name}
                            descn={
                              product?.short_description ||
                              product?.product_detail?.about
                            }
                            selling_price={variant?.s_price}
                            mrp={variant?.mrp}
                          />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              )}
            </div>

            <Shop_By_Brands userId={store?.user_id} />
            <New_In_Store userId={store?.user_id} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Store_Details;
